var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Prop, Watch } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseFollowRecordService } from "~/services/business-service/case-follow-record.service";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import ViewRecoredFiles from "~/components/collection-manage/execution/follow-query-base/view-recored-files.vue";
var collectionManageModule = namespace("collection-manage");
var FollowAllQuery = /** @class */ (function (_super) {
    __extends(FollowAllQuery, _super);
    function FollowAllQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.followQuery = {
            certificateNo: ""
        };
        _this.loading = { state: false };
        _this.currentCase = {};
        _this.current = {};
        _this.dialog = {
            certificate: false,
            record: false,
            video: false,
            phone: false,
            recordFiles: false
        };
        return _this;
    }
    /**
     * 调解执行页面使用
     */
    FollowAllQuery.prototype.onRecordCountChange = function () {
        this.refreshData();
    };
    FollowAllQuery.prototype.collectionDelete = function (id) {
        var _this = this;
        this.$confirm("是否确认删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            var deleteModel = {
                id: id,
                caseType: _this.otherData.caseType
            };
            _this.caseFollowRecordService
                .deleteCaseFollowRecord(deleteModel)
                .subscribe(function (data) {
                _this.$message.success("删除成功!");
                _this.refreshData();
            });
        })
            .catch(function () { });
    };
    FollowAllQuery.prototype.onCaseIdChange = function (val) {
        val && this.refreshData();
    };
    /**
     *下载
     */
    FollowAllQuery.prototype.downLoadFile = function (follow, type) {
        var _this = this;
        this.currentCase = follow;
        if (type === 2) {
            this.currentCase.record.forEach(function (x) {
                _this.uploadFileService
                    .getFileStreamById(x.id, x.fileName)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
            });
        }
        else if (type === 3) {
            this.currentCase.video.forEach(function (x) {
                _this.uploadFileService
                    .getFileStreamById(x.id, x.fileName)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
            });
        }
        else {
            this.currentCase.opUrl.forEach(function (x) {
                _this.uploadFileService
                    .getFileStreamById(x.id, x.fileName)
                    .subscribe(function () { return _this.$message.success("下载成功"); });
            });
        }
    };
    /**
     *查看看凭证
     */
    FollowAllQuery.prototype.certificateDetails = function (follow, type) {
        this.currentCase = follow;
        if (type === 1) {
            this.dialog.certificate = true;
        }
        else if (type === 2) {
            this.dialog.record = true;
        }
        else if (type === 3) {
            this.dialog.video = true;
        }
        else {
            this.dialog.phone = true;
        }
    };
    FollowAllQuery.prototype.refreshData = function () {
        var _this = this;
        this.followQuery.certificateNo = this.certificateNo;
        this.loading.state = true;
        this.caseFollowRecordService
            .getAllCaseFollowRecord(this.followQuery, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        }, function (err) { return _this.$message.error(err.msg); });
    };
    FollowAllQuery.prototype.viewRecordFiles = function (row) {
        this.current = row;
        this.dialog.recordFiles = true;
    };
    __decorate([
        Dependencies(PageService)
    ], FollowAllQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], FollowAllQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseFollowRecordService)
    ], FollowAllQuery.prototype, "caseFollowRecordService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], FollowAllQuery.prototype, "uploadFileService", void 0);
    __decorate([
        collectionManageModule.State
    ], FollowAllQuery.prototype, "recordCount", void 0);
    __decorate([
        collectionManageModule.State
    ], FollowAllQuery.prototype, "otherData", void 0);
    __decorate([
        Prop({ required: true, default: "" })
    ], FollowAllQuery.prototype, "certificateNo", void 0);
    __decorate([
        Watch("recordCount")
    ], FollowAllQuery.prototype, "onRecordCountChange", null);
    __decorate([
        Watch("caseId", { immediate: true })
    ], FollowAllQuery.prototype, "onCaseIdChange", null);
    FollowAllQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ViewRecoredFiles: ViewRecoredFiles
            }
        })
    ], FollowAllQuery);
    return FollowAllQuery;
}(Vue));
export default FollowAllQuery;
